<template>
  <section>
    <Confirm
      :confirm.sync="confirmDelete"
      :callback="deleteBot"
      message="Are you sure you want to delete this bot? All data associated with the main menu pages will be removed! If you want to migrate the data from this bot to another bot, please contact support."
    ></Confirm>
  
    <v-speed-dial v-model="fab" :absolute="true" :top="true" :right="true" direction="bottom">
      <template v-slot:activator>
        <v-btn v-model="fab" color="primary" dark fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-plus-box-multiple</v-icon>
        </v-btn>
      </template>
      <v-btn fab light small @click="newBot()">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-btn fab dark small color="red" @click="confirmDelete = true" v-if="bot && bot.id">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-speed-dial>

    <v-progress-linear
      indeterminate
      color="primary"
      v-if="botLoading"
      absolute
      class="mt-n3"
      height="7"
    ></v-progress-linear>
    <v-row>
      <v-col class="px-6" cols="12">
        <BotView :bot="bot" v-if="!botLoading && bot.id"></BotView>
        <BotForm :bot="bot" v-if="!botLoading && !bot.id"></BotForm>
      </v-col>
    </v-row>
    <v-row v-if="bot.id">
      <v-col class="px-6" cols="12">
        <v-tabs v-model="tab" grow>
          <v-tab>Information</v-tab>
          <v-tab v-if="enabledFeatures && enabledFeatures.webhooks">Webhooks</v-tab>
          <v-tab v-if="enabledFeatures && enabledFeatures.api_access">API</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <BotInfo :bot="bot" v-if="!botLoading && bot.id"></BotInfo>
          </v-tab-item>
          <v-tab-item v-if="enabledFeatures && enabledFeatures.webhooks">
            <Webhook v-if="!botLoading && bot.id"></Webhook>
          </v-tab-item>
          <v-tab-item v-if="enabledFeatures && enabledFeatures.api_access">
            <APIAccess :bot="bot" v-if="!botLoading && bot.id"></APIAccess>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { models } from "feathers-vuex";
import { makeGetMixin } from "feathers-vuex";

import BotView from "@/components/config/bot/BotView";
import BotForm from "@/components/config/bot/BotForm";
import BotInfo from "@/components/config/bot/BotInfo";
import Webhook from "@/components/config/bot/Webhook";
import APIAccess from "@/components/config/bot/APIAccess";
import Confirm from "@/components/widget/Confirm";

export default {
  data: () => ({
    bot: {},
    fab: null,
    configId: "enabledFeatures",
    botLoading: false,
    tab: 0,
    confirmDelete: false,
  }),
  mounted() {
    if (this.selectedBot) {
      this.bot = this.selectedBot;
    } else {
      this.newBot();
    }
  },
  mixins: [
    makeGetMixin({ service: "configuration", id: "configId", name: "featuresConfig" })
  ],
  computed: {
    ...mapGetters("apiAuth", ["user"]),
    ...mapGetters("app", ["selectedBot"]),
    featuresConfigParams() {
      return {
        query: {},
      };
    },
    enabledFeatures() {
      return this.featuresConfig && this.featuresConfig.config;
    },
    botIsSetup() {
      return this.user &&
        this.user.account &&
        this.user.account.bots &&
        this.user.account.bots.length
        ? this.user.account.bots[0]
        : null;
    },
  },
  methods: {
    ...mapActions("users", { getUser: "get" }),
    ...mapActions("bots", { removeBot: "remove" }),
    ...mapActions("config", ["apiUrlSet"]),
    async newBot() {
      const { Bot } = models.api;
      this.bot = new Bot();
    },
    async deleteBot() {
      await this.removeBot(this.bot.id);
      location.reload();
    }
  },
  watch: {
    selectedBot(botNow, botBefore) {
      if (botNow && botNow !== botBefore) {
        this.bot = botNow;
      }
    },
    bot: {
      async handler(botNow) {
        const botApiUrl = localStorage.getItem("botApiUrl");
        console.log(`Bot dyno state: ${botNow.dyno_state}...`);

        if (
          botNow &&
          botNow.dyno_state &&
          botNow.dyno_state.toLowerCase() === "up" &&
          botApiUrl !== botNow.app_url
        ) {
          await this.getUser(this.user.id);
          this.apiUrlSet(botNow.app_url);
          location.reload();
        }
      },
      deep: true,
    },
  },
  components: {
    BotView,
    BotForm,
    BotInfo,
    Webhook,
    APIAccess,
    Confirm
  },
};
</script>